export default {"src":"/_next/static/media/turkish_shower.ad298f54.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};